module.exports = __webpack_public_path__ + "media/SERF25-0800-Artificial_Intelligence.64ddf533.mp4";